<template>
    <div class="adds-messages-list">
        <ActionButton v-if="AccountController.account.premium.allowed "
            v-tooltip='"messages.ads.tooltip_remove"'
            :gtm="{
                module : 'ads',
                feature: 'ads_remove_modal',
                block  : 'message_list',
                action : 'open'
                }"
            class="close"
            icon="fas fa-times-circle"
            type="icon"
            @click="onRemoveAds()"
        />
        <div class="content">
            <iframe ref="iframe_element" :src="src" frameborder="0" height="100px" scrolling="no" width="100%"></iframe>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch }           from 'vue';
    import LayoutSettingsController from '@/js/Webmail/LayoutSettingsController';
    import AccountController        from '@/js/Webmail/AccountController';
    import ActionButton             from '@/vue/Elements/Buttons/ActionButton.vue';
    import SAPOMailConfig           from '@/SAPOMailConfig';

    const iframe_element = ref(null);
    const config         = SAPOMailConfig.server.ads['GPT_IFRAME_BANNER_320_SLOT_1'];
    const src            = config.host
        + '?theme=' + LayoutSettingsController.theme
        + '&color_scheme=' + LayoutSettingsController.color_scheme;

    const emit = defineEmits(['removeAds']);

    watch(() => LayoutSettingsController.theme, () => {
        notifyIframe();
    });

    watch(() => LayoutSettingsController.color_scheme, () => {
        notifyIframe();
    });

    const onRemoveAds = () => {
        emit('removeAds');
    };

    const notifyIframe = () => {
        if (!iframe_element.value || !iframe_element.value.contentWindow) {
            return;
        }

        iframe_element.value.contentWindow.postMessage(
            {
                type        : 'change-theme',
                theme       : LayoutSettingsController.theme,
                color_scheme: LayoutSettingsController.color_scheme
            },
            '*'
        );
    };
</script>
